import React, {Fragment} from 'react';

export default function CsfBrokerSearchCompliance(props) {

  let ufcSubjects = [];
  if (props.data.length > 0) {
    ufcSubjects = Array.apply(null, {length: Object.keys(props.data[0]).filter(key => key.startsWith('Nom_Francais_')).length}).map(Number.call, Number);
  }
  let langcode = document.querySelector('html').getAttribute('lang');

  return (
    <div className="table-wrapper">
      <table id="broker-compliance-table">
        <caption className="sr-only">{window.Drupal.t('broker.compliance.titlePage')}</caption>
        <thead>
          <tr>
            <th>
              {window.Drupal.t('broker.compliance.header.certificateNumber')}
            </th>
            <th>
              {window.Drupal.t('broker.compliance.header.name')}
            </th>
            {/* "AAAAAAAAABs=" corresponds to previous period */}
            {props.selectedPeriods == "AAAAAAAAABs=" && (
              <th>
                {window.Drupal.t('broker.compliance.header.classes')}
              </th>
            )}
            <th>
              {window.Drupal.t('broker.compliance.header.ufc')}
            </th>
          </tr>
        </thead>

        <tbody>
        {props.data.length == 0 && (
          <tr>
            <td colSpan="5">
              <p>{window.Drupal.t('search.noResult')}</p>
            </td>
          </tr>
        )}

        {props.data.map((item, indexParent) => (
          <Fragment key={`consent-table-row${indexParent}`}>
            <tr className="activities__base-info">
              <td>
                {item.Member_Number && (
                  <>{item.Member_Number}</>
                )}
              </td>
              <td>
                {item.Member_FirstName && item.Member_LastName && (
                  <>{item.Member_FirstName.toLowerCase().replace(/(^|[\s-])([a-z])/g, (char) => char.toUpperCase()) + ' ' + item.Member_LastName.toLowerCase().replace(/(^|[\s-])([a-z])/g, (char) => char.toUpperCase())}</>
                )}
              </td>
            {/* "AAAAAAAAABs=" corresponds to previous period */}
            {props.selectedPeriods == "AAAAAAAAABs=" && (
              <td className="course-status row m-0">
                {item.REDU_UFC_Required_NA ? (
                  <>
                    <span className="col-8 p-0">{window.Drupal.t('broker.compliance.ufcRequireNA')}</span>
                    <img className="compliance-icon col p-0" src="/themes/custom/tink/dist/assets/not-applicable.svg" alt=""/>
                  </>
                ) : (
                  <>
                  {item.REDU_UFC_Acquired_Mandatory && (
                    <>
                      <span className="col-8 p-0">{window.Drupal.t('broker.compliance.ufcAcquiredMandatory.fromapi')}</span>
                      <img className="compliance-icon col p-0" src="/themes/custom/tink/dist/assets/circle-green-checkmark.svg" alt=""/>
                    </>
                  )}
                  {!item.REDU_UFC_Acquired_Mandatory && (
                    <>
                      <span className="col-8 p-0">{window.Drupal.t('broker.compliance.noUfcAcquiredMandatory.fromapi')}</span>
                      <img className="compliance-icon col p-0" src="/themes/custom/tink/dist/assets/icon-non-cross.svg" alt=""/>
                    </>
                  )}
                  </>
                )}
              </td>
            )}
              <td>
                <div className="row m-0 align-items-center">
                  <div className="course-status col p-0">
                    <div className="row m-0">
                      {item.Member_In_Order === 'Oui' ? (
                        <>
                        <span className="col-8 p-0">{window.Drupal.t('broker.compliance.conform.fromapi')}</span>
                        <img className="compliance-icon col p-0" src="/themes/custom/tink/dist/assets/circle-green-checkmark.svg" alt=""/>
                        </>
                      ) : (
                        <>
                        <span className="col-8 p-0">{window.Drupal.t('broker.compliance.noConform.fromapi')}</span>
                        <img className="compliance-icon col p-0" src="/themes/custom/tink/dist/assets/icon-non-cross.svg" alt=""/>
                        </>
                      )}
                    </div>
                  </div>
                  <button className="col-auto table-accordion btn-link ml-auto"
                          type="button" data-toggle="collapse"
                          data-target={`#collapse-${indexParent}`} aria-expanded="false"
                          aria-controls={`collapse-${indexParent}`}
                          aria-label={`${item.Member_Number} - ${window.Drupal.t('membre.summary.detail.aria-label')}`}>
                    <img className="img-arrow"
                          src="/themes/custom/tink/dist/assets/chevron-left.svg" alt="chevron"/>
                  </button>
                </div>
              </td>
            </tr>

            <tr className="activities__more-info">
              <td colSpan="4" className="p-0">
                <div className="accordion-collapse collapse" id={`collapse-${indexParent}`}>
                  <div className="table-wrapper mb-2">
                    <table>
                      <thead>
                        <tr>
                          <th>
                            {window.Drupal.t('membre.summary.category')}
                          </th>
                          <th>
                            {window.Drupal.t('membre.summary.asked-ufc')}
                          </th>
                          <th>
                            {window.Drupal.t('membre.summary.completed-ufc')}
                          </th>
                          <th>
                            {window.Drupal.t('membre.summary.missing-ufc')}
                          </th>
                          <th width="148">
                            {window.Drupal.t('membre.summary.completed')}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {ufcSubjects.map((ufcSubject, index) => (
                        <tr key={`accordion-${indexParent}-${index}`} >
                          <td>
                            {langcode === "en" && (
                              <>
                              {index + 1 === 4 ? (
                                item[`Nom_English_M${index + 1}`] ? item[`Nom_English_M${index + 1}`] : "N/A"
                              ) : (
                                item[`Nom_Anglais_M${index + 1}`] ? item[`Nom_Anglais_M${index + 1}`] : "N/A"
                              )}
                              </>
                            )}
                            {langcode === "fr" && (
                              <>{item[`Nom_Francais_M${index + 1}`] ? item[`Nom_Francais_M${index + 1}`] : "N/A"}</>
                            )}
                          </td>
                          <td>
                            {item[`Requis_M${index + 1}`] == null || item[`Requis_M${index + 1}`] === '' ? (
                              'N/A'
                            ) : `${item[`Requis_M${index + 1}`]} ${window.Drupal.t('PDU')}`}
                          </td>
                          <td>
                            {item[`Acquis_M${index + 1}`] == null || item[`Acquis_M${index + 1}`] === '' ? (
                              'N/A'
                            ) : `${item[`Acquis_M${index + 1}`]} ${window.Drupal.t('PDU')}`}
                          </td>
                          <td>
                            {item[`Manquant_M${index + 1}`] == null || item[`Manquant_M${index + 1}`] === '' ? (
                              'N/A'
                            ) : `${item[`Manquant_M${index + 1}`]} ${window.Drupal.t('PDU')}`}
                          </td>
                          <td className="course-status">
                            {item[`Manquant_M${index + 1}`] == null || item[`Manquant_M${index + 1}`] === '' ? (
                                <span title={window.Drupal.t('membre.tag.na.tooltip')}
                                  className="espaces__tag espaces__tag--gray espaces__tag--slim">{window.Drupal.t('membre.tag.na')}</span>
                              ) : item[`Manquant_M${index + 1}`] > 0 ? (
                                <span className="espaces__tag espaces__tag--error espaces__tag--slim">{window.Drupal.t('No')}</span>
                              ) : (
                                <span className="espaces__tag espaces__tag--slim">{window.Drupal.t('Yes')}</span>
                              )}
                          </td>
                        </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}
